export default {
    update_user_information(state, data) {
        state.userInformation = data
    }
}
